import {
  ASSOCIATE_NEW_HANDLERS_REQUEST,
  ASSOCIATE_NEW_HANDLERS_SUCCESS,
  ASSOCIATE_NEW_HANDLERS_FAILURE,
  COPY_HANDLERS_REQUEST,
  COPY_HANDLERS_SUCCESS,
  COPY_HANDLERS_FAILURE,
  EDIT_HANDLERS_REQUEST,
  EDIT_HANDLERS_SUCCESS,
  EDIT_HANDLERS_FAILURE,
  GET_MRD_BY_COUNTRY_REQUEST,
  GET_MRD_BY_COUNTRY_SUCCESS,
  GET_MRD_BY_COUNTRY_FAILURE,
  CLEAR_MRD_SELECTION,
  GET_ALL_HANDLERS_REQUEST,
  GET_ALL_HANDLERS_SUCCESS,
  GET_ALL_HANDLERS_FAILURE,
  GET_HANDLERS_BY_MRD_REQUEST,
  GET_HANDLERS_BY_MRD_SUCCESS,
  GET_HANDLERS_BY_MRD_FAILURE,
  CREATE_NEW_HANDLER_REQUEST,
  CREATE_NEW_HANDLER_SUCCESS, CREATE_NEW_HANDLER_FAILURE,
} from './types/HandlersActionTypes';

export function postAssociateHandlerRequestActionCreator(name, associateCommandList) {
  return {
    type: ASSOCIATE_NEW_HANDLERS_REQUEST,
    payload: {
      mrdName: name,
      associateHandlerCommandList: associateCommandList,
    },
  };
}

export function postAssociateHandlerSuccessActionCreator(payload) {
  return {
    type: ASSOCIATE_NEW_HANDLERS_SUCCESS,
    payload,
  };
}

export function postAssociateHandlerFailureActionCreator(payload) {
  return {
    type: ASSOCIATE_NEW_HANDLERS_FAILURE,
    payload,
    error: true,
  };
}

export function postCopyHandlerRequestActionCreator(payload) {
  return {
    type: COPY_HANDLERS_REQUEST,
    payload,
  };
}

export function postCopyHandlerSuccessActionCreator(payload) {
  return {
    type: COPY_HANDLERS_SUCCESS,
    payload,
  };
}

export function postCopyHandlerFailureActionCreator(payload) {
  return {
    type: COPY_HANDLERS_FAILURE,
    payload,
    error: true,
  };
}

export function getMrdByCountryRequestActionCreator(payload) {
  return {
    type: GET_MRD_BY_COUNTRY_REQUEST,
    payload,
  };
}

export function getMrdByCountrySuccessActionCreator(payload) {
  return {
    type: GET_MRD_BY_COUNTRY_SUCCESS,
    payload,
  };
}

export function getMrdByCountryFailureActionCreator(payload) {
  return {
    type: GET_MRD_BY_COUNTRY_FAILURE,
    payload,
    error: true,
  };
}

export function putEditHandlersRequestActionCreator(payload) {
  return {
    type: EDIT_HANDLERS_REQUEST,
    payload,
  };
}

export function putEditHandlersSuccessActionCreator(payload) {
  return {
    type: EDIT_HANDLERS_SUCCESS,
    payload,
  };
}

export function putEditHandlersFailureActionCreator(payload) {
  return {
    type: EDIT_HANDLERS_FAILURE,
    payload,
    error: true,
  };
}

export function clearPreservedMrdSelection() {
  return {
    type: CLEAR_MRD_SELECTION,
  };
}

export function getAllHandlersRequestActionCreator(payload) {
  return {
    type: GET_ALL_HANDLERS_REQUEST,
    payload,
  };
}

export function getAllHandlersSuccessActionCreator(payload) {
  return {
    type: GET_ALL_HANDLERS_SUCCESS,
    payload,
  };
}

export function getAllHandlersFailureActionCreator(payload) {
  return {
    type: GET_ALL_HANDLERS_FAILURE,
    payload,
    error: true,
  };
}

export function getHandlersByMrdRequestActionCreator(payload) {
  return {
    type: GET_HANDLERS_BY_MRD_REQUEST,
    payload,
  };
}

export function getHandlersByMrdSuccessActionCreator(payload) {
  return {
    type: GET_HANDLERS_BY_MRD_SUCCESS,
    payload,
  };
}

export function getHandlersByMrdFailureActionCreator(payload) {
  return {
    type: GET_HANDLERS_BY_MRD_FAILURE,
    payload,
    error: true,
  };
}

export function postCreateNewHandlerRequestActionCreator(payload) {
  return {
    type: CREATE_NEW_HANDLER_REQUEST,
    payload,
  };
}

export function postCreateNewHandlerSuccessActionCreator(payload) {
  return {
    type: CREATE_NEW_HANDLER_SUCCESS,
    payload,
  };
}

export function postCreateNewHandlerFailureActionCreator(payload) {
  return {
    type: CREATE_NEW_HANDLER_FAILURE,
    payload,
    error: true,
  };
}
